const steps = [
  {
    number: '01',
    word: 'Vision',
    body: 'Share the feeling, the space, the story you want to tell. No brief is too abstract.',
  },
  {
    number: '02',
    word: 'Creation',
    body: 'Each mark is made by hand, with patience and precision. The work takes the time it deserves.',
  },
  {
    number: '03',
    word: 'Refinement',
    body: 'Details are considered, adjusted, and perfected until the piece is exactly right.',
  },
  {
    number: '04',
    word: 'Final Piece',
    body: 'Your original artwork arrives — ready to become the centerpiece of your space.',
  },
];

const ProcessSection = () => (
  <section id="process" className="w-full bg-[#2C2420] py-36 px-6 md:px-12 lg:px-20 overflow-hidden">
    <div className="max-w-7xl mx-auto">
      {/* Header */}
      <div className="mb-28">
        <div className="flex items-center gap-5 mb-10">
          <div className="w-16 h-px bg-[#C9A96E]/50"></div>
          <span className="text-[#C9A96E]/65 uppercase tracking-[0.5em] text-[9px] font-light">The Journey</span>
        </div>
        <h2 className="font-serif text-white/90 leading-[0.9] tracking-[-0.01em]" style={{ fontSize: 'clamp(3rem, 6vw, 5.5rem)', fontWeight: 300 }}>
          An Artistic<br />
          <em className="italic text-[#D4B483]" style={{ fontWeight: 300 }}>Process</em>
        </h2>
      </div>

      {/* Steps */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-0">
        {steps.map((step, i) => (
          <div key={step.number} className="relative group border-l border-white/8 first:border-l-0 pl-10 first:pl-0 py-2">
            <div
              className="font-serif text-white/[0.06] leading-none select-none group-hover:text-[#C9A96E]/[0.12] transition-colors duration-700"
              style={{ fontSize: '9rem', fontWeight: 200 }}
            >
              {step.number}
            </div>
            <h3
              className="font-serif text-white/75 leading-none -mt-10 mb-6 group-hover:text-white transition-colors duration-500"
              style={{ fontSize: 'clamp(1.6rem, 2.5vw, 2.2rem)', fontWeight: 300 }}
            >
              {step.word}
            </h3>
            <div className="w-8 h-px bg-[#C9A96E]/35 mb-6 group-hover:w-14 group-hover:bg-[#C9A96E]/60 transition-all duration-500"></div>
            <p className="text-white/30 text-xs leading-[2.1] tracking-[0.05em] font-light pr-6 group-hover:text-white/50 transition-colors duration-500">
              {step.body}
            </p>
            {i < steps.length - 1 && (
              <div className="hidden lg:block absolute top-[5.5rem] right-0 w-2 h-px bg-white/8 translate-x-1/2"></div>
            )}
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ProcessSection;
